import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const StarIconSvg = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_194_3695"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <path d="M0 0.394531H20V19.6045H0V0.394531Z" fill="white" />
    </mask>
    <g mask="url(#mask0_194_3695)">
      <path
        d="M19.95 8.60421C19.87 8.9332 19.6964 9.23194 19.45 9.46421L16.15 12.6842C16.1166 12.7193 16.0895 12.7599 16.07 12.8042C16.0603 12.8504 16.0603 12.898 16.07 12.9442L16.85 17.5042C16.915 17.8402 16.88 18.1882 16.75 18.5042C16.6296 18.8169 16.4168 19.0854 16.14 19.2742C15.8711 19.4727 15.5529 19.5938 15.22 19.6242H15.09C14.7969 19.6248 14.5083 19.5527 14.25 19.4142L10.15 17.2742C10.1074 17.2496 10.0592 17.2367 10.01 17.2367C9.96085 17.2367 9.91257 17.2496 9.87 17.2742L5.77 19.4242C5.46245 19.5852 5.11633 19.6579 4.77 19.6342C4.43365 19.6055 4.11179 19.4844 3.84 19.2842C3.56581 19.0884 3.354 18.8175 3.23 18.5042C3.10347 18.1869 3.06882 17.8403 3.13 17.5042L3.91 12.9542C3.92455 12.9087 3.92455 12.8597 3.91 12.8142C3.89445 12.7701 3.8707 12.7294 3.84 12.6942L0.54 9.45421C0.300264 9.22237 0.130481 8.92785 0.0499998 8.60421C-0.0472656 8.27797 -0.0472656 7.93044 0.0499998 7.60421C0.159935 7.28311 0.357935 6.99939 0.621399 6.78543C0.884864 6.57148 1.20318 6.43591 1.54 6.39421L6.04 5.73421C6.08483 5.73307 6.12762 5.71524 6.16 5.68421C6.19811 5.655 6.22892 5.61735 6.25 5.57421L8.35 1.39421C8.493 1.09421 8.719 0.841206 9 0.664206C9.21359 0.529328 9.45331 0.441185 9.7034 0.405572C9.95349 0.36996 10.2083 0.387685 10.451 0.457581C10.6938 0.527478 10.919 0.647964 11.1118 0.811117C11.3047 0.97427 11.4608 1.1764 11.57 1.40421L13.65 5.56421C13.6751 5.61039 13.7091 5.65117 13.75 5.68421C13.7864 5.71518 13.8322 5.73281 13.88 5.73421L18.45 6.39421C18.782 6.44421 19.094 6.58621 19.35 6.80421C19.601 7.02121 19.791 7.30021 19.9 7.61421C20.006 7.93421 20.024 8.27621 19.95 8.60421Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const StarIcon: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={StarIconSvg} {...props} />
);

export default StarIcon;

StarIcon.displayName = "StarIcon";
